/* ==========================================================================
   Floricultura Edelweiss — montador de assinatura.
   Depende de app.js, que expõe window.EDELWEISS.

   POR QUE ISTO NÃO ENTRA NA SACOLA, e sim no WhatsApp.
   O resto do protótipo empurra tudo para a sacola em localStorage, e seria
   fácil fazer o mesmo aqui. Não faz, por dois motivos que são do negócio e
   não do código:
     a) assinatura é combinado, não compra avulsa. Endereço, janela e a data
        da primeira entrega precisam ser acertados com alguém — e o próprio
        checkout do protótipo termina no WhatsApp de qualquer jeito;
     b) se as assinaturas entrassem em PRODUTOS para caber na sacola, elas
        apareceriam na grade do catálogo e na home, misturadas com as peças
        avulsas. A página nasceu justamente para NÃO ter seção na home.

   Por isso os dados vivem aqui, e não no app.js: nada neste arquivo é
   catálogo, e nada daqui deve vazar para a listagem.
   ========================================================================== */
(function () {
  'use strict';

  var E = window.EDELWEISS;
  if (!E) return;

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var money = E.money;

  var alvo = $('[data-assinatura]');
  if (!alvo) return;

  /* =======================================================================
     DADOS

     O PREÇO É POR MÊS, E É UMA MATRIZ — não é "preço da peça × entregas".
     Esta é a mudança que a tabela da loja trouxe em 14/08/2026: a mensalidade
     de cada porte muda conforme a frequência, e não proporcionalmente. Quem
     assina semanal paga menos por entrega do que quem assina mensal.

     ARRANJOS: NÚMEROS REAIS, da tabela que a Edelweiss mandou
     ("Tabela Assinatura 2", recebida em 14/08/2026):

       Tamanho   Composição              Mensal   Quinzenal   Semanal
       Pocket    10 hastes + folhagem    R$ 119   R$ 219      R$ 399
       Classic   15 hastes + folhagem    R$ 149   R$ 279      R$ 499
       Premium   20 hastes + folhagem    R$ 199   R$ 369      R$ 649

     Os nomes dos portes são os da loja — Pocket, Classic e Premium —, e não
     Pequeno/Médio/Grande, que era o que estava aqui antes. Nome de plano é
     coisa que o cliente repete no WhatsApp: tem de bater com o que a casa fala.

     ORQUÍDEA: TRÊS TAMANHOS DESDE 18/08/2026 — MINI, MÉDIA E GRANDE.
     A pedido do Erik, o grupo que era peça única voltou a ser escolha. O eixo
     do tamanho é o mesmo que a loja já usa para falar da peça: quantas hastes
     a planta carrega e em que aquário ela vai plantada.

       Tamanho   Composição                                   Mensal
       Mini      Mini orquídea, uma haste — aquário M         R$ 199
       Média     Uma orquídea, duas hastes — aquário M        R$ 300
       Grande    Seis hastes ou mais — aquário G               R$ 900

     OS TRÊS PREÇOS SÃO DADO DA LOJA (19/08/2026). Isto derrubou os dois
     números provisórios que este arquivo carregava desde 18/08 — R$ 499 e
     R$ 699, derivados da forma afim da tabela de arranjo. A derivação era
     defensável e errou por muito: a loja pratica 199 e 300, ou seja, a curva
     da orquídea NÃO é a do arranjo. Se algum dia faltar preço de um tamanho
     novo, não repetir a extrapolação — perguntar.
     Os R$ 900/mês da Grande continuam sendo o número de 14/08/2026 e são a
     peça que o Erik fotografou: três Phalaenopsis no aquário G.

     O AQUÁRIO VOLTOU A SER DITO NO CARTÃO, e só na Mini e na Média: as duas
     vão em aquário tamanho M (loja, 19/08/2026). Este arquivo tinha registrado
     o contrário em 18/08 — "não dizer o tamanho do aquário, porque a foto
     desmente" —, e o argumento era de foto, não de produto: a Mini aparece com
     vidro visivelmente menor que a Média na série publicada. O dado da loja
     manda, então o texto entra; o que fica pendente é a FOTO da Mini, que hoje
     mostra um vidro que o cartão dela diz ser do mesmo tamanho do da Média.
     Quem for refazer a série: Mini e Média no MESMO vidro, mudando só a haste.

     PENDÊNCIA FECHADA EM 19/08/2026. A série foi refeita no Magnific (Nano
     Banana Pro) e a Mini agora usa o mesmo vidro da Média. Medido na largura
     do bojo, em quadro de 1200 px: Mini 418 px, Média 411 px — 1,7% de
     diferença, ou seja o mesmo vidro. A Grande subiu para o aquário G, dado do
     Erik no mesmo dia (M = Ø16 × h14 cm, G = Ø21 × h18 cm): 534 px, que é
     1,30x a Média contra os 1,31x que a razão real pede. Por isso o "aquário
     G" entrou no cartão da Grande — antes faltava o dado, não a intenção.
     COMO A MINI FOI FEITA, porque a primeira tentativa falhou: ancorar na foto
     da PEQUENA e mandar o vidro crescer devolveu três saídas com o vidro do
     tamanho antigo — a âncora vence adjetivo e vence fração de quadro. O que
     funcionou foi inverter: ancorar na foto da MÉDIA, que já tinha o vidro
     certo, mandar o vidro NÃO mudar de tamanho, e trocar só a planta para uma
     haste. Série anterior guardada em `img/_orquidea-vidro-v2/`.

     A FREQUÊNCIA MENSAL CONTINUA SENDO A ÚNICA, para os três tamanhos. Não é
     regra de produto inventada — é o alcance do dado, e o mesmo argumento de
     14/08/2026: publicar um valor quinzenal ou semanal exigiria derivar mais
     números que ninguém informou, no item mais caro da página. A restrição
     também não briga com o produto: orquídea é planta viva e dura semanas, o
     que já era dito na peça avulsa do catálogo ("dura semanas, não dias"). Se
     a loja passar a praticar as outras frequências, basta acrescentar as
     chaves em `precos` e os ids em `freqs` — o resto da página se ajusta
     sozinho.

     E O DESCONTO POR FREQUÊNCIA AGORA EXISTE, o que derruba a decisão anterior
     deste arquivo de não ter nenhum. A razão de não ter era não saber quanto a
     casa abre mão por receita recorrente — isso era decisão do dono, e agora
     ele decidiu. A página não anuncia o desconto em percentual: mostra o valor
     por entrega ao lado do mensal, e a conta aparece sozinha.
     ======================================================================= */
  /* =======================================================================
     AS FOTOS DAS OPÇÕES (14/08/2026)

     SÓ O GRUPO "QUE TAMANHO" TEM FOTO. Decisão do Erik, e ela está certa pelo
     que cada grupo faz:

     · "O que vem" separa orquídea de arranjo — duas coisas que a pessoa já
       distingue pelo nome. Foto ali não decide nada, e dois retratos grandes
       antes da primeira escolha empurram o resto da página para baixo da
       dobra.
     · "Que tamanho" é o único grupo em que a diferença NÃO cabe no texto.
       "6 hastes" contra "15 hastes" é um número que ninguém consegue imaginar
       em volume; é exatamente o trabalho que a foto faz melhor do que a
       palavra. É aqui que a imagem paga o espaço que ocupa.
     · A frequência não tem foto porque intervalo de tempo não se fotografa.
     · A ORQUÍDEA TAMBÉM É "que tamanho" DESDE 18/08/2026, e por isso o mesmo
       argumento passou a valer para ela: a diferença entre uma haste, duas
       hastes em cascata e seis é volume, e volume não cabe no texto. Antes
       ela era peça única e a foto tinha outra função — responder "o que são
       R$ 900 por mês", que é a pergunta que o cartão mais caro da página
       deixa aberta. Essa função continua, agora dentro do cartão da Grande.
     · AS TRÊS FOTOS EXISTEM desde a tarde de 18/08/2026 (Magnific, Nano
       Banana Pro), geradas na mesma rodada e ancoradas na foto que já estava
       publicada — por isso são o mesmo peitoril, a mesma luz e a mesma
       câmera, e por isso se leem em ordem. O rolo de sisal ao lado do vidro é
       o MESMO em todas as três: é ele que dá a escala, já que o quadro não
       muda. O interruptor por grupo, lá embaixo, tinha sido feito para
       segurar o grupo sem foto enquanto elas faltavam; agora ele só liga.

     Corte único, 4:5, que é o corte de PRODUTO do §6 dos tokens: o retrato é
     o que dá altura para a peça crescer dentro do quadro, e é isso que faz os
     três tamanhos se lerem em ordem.

     Se o arquivo não existir, o `onerror` esconde só o <img> e sobra a chapa
     — nunca o ícone de imagem quebrada.
     ======================================================================= */
  var TIPOS = [
    { id: 'orquidea', nome: 'Orquídea',
      /* `nomeLongo` é o nome que aparece no resumo e na mensagem do WhatsApp. */
      nomeLongo: 'Orquídea phalaenopsis',
      d: 'Orquídea phalaenopsis: planta viva, no aquário de vidro. Dura semanas, não dias.',
      freqs: ['mensal'],
      /* A cor vem ANTES do tamanho (pedido do Erik, 21/10/2026). A lilás só existe
         na Média; as fotos de cada tamanho ficam em `cores` dentro do porte. */
      cores: [ { id: 'branca', nome: 'Branca' }, { id: 'lilas', nome: 'Lilás' } ],
      portes: [
        /* Mini e Média: preço e aquário são dado da loja de 19/08/2026. O id
           continua 'pequena' de propósito — é o nome do arquivo da foto e do
           estado salvo; só o rótulo virou "Mini", que é como a casa fala. */
        { id: 'pequena', nome: 'Mini', d: 'Mini orquídea, uma haste — aquário M',
          img: '//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-assina-orquidea-pequena.jpg?v=151036907509295141651792607264?v=6',
          alt: 'Mini orquídea phalaenopsis branca de uma haste arqueada, com flores de garganta amarela, plantada em aquário redondo de vidro transparente com casca de pinus, musgo e raízes aéreas, sobre bancada de pedra clara, no mesmo aquário e na mesma distância de câmera da Média.',
          cores: [
            { id: 'branca', nome: 'Branca',
              img: '//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-assina-orquidea-pequena.jpg?v=151036907509295141651792607264?v=6',
              alt: 'Mini orquídea phalaenopsis branca de uma haste arqueada, com flores de garganta amarela, plantada em aquário redondo de vidro transparente com casca de pinus, musgo e raízes aéreas, sobre bancada de pedra clara, no mesmo aquário e na mesma distância de câmera da Média.' },
            { id: 'lilas', nome: 'Lilás',
              img: '//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-assina-orquidea-pequena-lilas.jpg?v=119678479523136441711792609764?v=1',
              alt: 'Mini orquídea phalaenopsis lilás de uma haste arqueada, com flores lavanda de garganta magenta, plantada em aquário redondo de vidro transparente com casca de pinus, musgo e raízes aéreas, sobre bancada de pedra clara, no mesmo aquário e na mesma distância de câmera da Média.' }
          ],
          precos: { mensal: 199 } },
        /* 21/10/2026: a cliente pediu a Phalaenopsis de DUAS HASTES em branca e
           lilás, as duas que mais saem. Em vez de um cartão por cor no meio dos
           tamanhos, a Média é UM cartão e a cor é um grupo à parte ("Qual cor"),
           que só aparece quando o tamanho escolhido tem `cores`. A foto do cartão
           acompanha a cor. O PREÇO É O MESMO nas duas (R$ 300, o que já estava
           no site para a Média). */
        { id: 'media', nome: 'Média', d: 'Duas hastes em cascata — aquário M',
          img: '//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-assina-orquidea-media-branca.jpg?v=149138488864823829541792607264?v=4',
          alt: 'Orquídea phalaenopsis branca de duas hastes arqueadas, com flores de garganta amarela e botões verdes nas pontas, plantada em aquário redondo de vidro transparente com casca de pinus, musgo e raízes aéreas, sobre bancada de pedra clara, com luz de janela vinda da esquerda.',
          cores: [
            { id: 'branca', nome: 'Branca',
              img: '//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-assina-orquidea-media-branca.jpg?v=149138488864823829541792607264?v=4',
              alt: 'Orquídea phalaenopsis branca de duas hastes arqueadas, com flores de garganta amarela e botões verdes nas pontas, plantada em aquário redondo de vidro transparente com casca de pinus, musgo e raízes aéreas, sobre bancada de pedra clara, com luz de janela vinda da esquerda.' },
            { id: 'lilas', nome: 'Lilás',
              img: '//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-assina-orquidea-media-lilas.jpg?v=138250555784057810211792607264?v=4',
              alt: 'Orquídea phalaenopsis lilás de duas hastes arqueadas, com flores lavanda de garganta magenta e botões verdes nas pontas, plantada em aquário redondo de vidro transparente com casca de pinus, musgo e raízes aéreas, sobre bancada de pedra clara, na mesma luz e no mesmo enquadramento da branca.' }
          ],
          precos: { mensal: 300 } },
        /* A ÚNICA COM PREÇO DE VERDADE (loja, 14/08/2026) e a única com foto
           de verdade: é a peça que o Erik fotografou. */
        { id: 'grande', nome: 'Grande', d: 'Seis hastes ou mais — aquário G',
          img: '//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-assina-orquidea-grande.jpg?v=49666963639541126041792605562?v=4',
          alt: 'Orquídea phalaenopsis branca de cinco ou seis hastes em arco, cheia de flores de garganta amarela, plantada em aquário redondo de vidro grande com casca de pinus, musgo e raízes aéreas, sobre bancada de mármore claro, junto a uma janela alta.',
          cores: [
            { id: 'branca', nome: 'Branca',
              img: '//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-assina-orquidea-grande.jpg?v=49666963639541126041792605562?v=4',
              alt: 'Orquídea phalaenopsis branca de cinco ou seis hastes em arco, cheia de flores de garganta amarela, plantada em aquário redondo de vidro grande com casca de pinus, musgo e raízes aéreas, sobre bancada de mármore claro, junto a uma janela alta.' },
            { id: 'lilas', nome: 'Lilás',
              img: '//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-assina-orquidea-grande-lilas.jpg?v=49430746103204735651792609764?v=1',
              alt: 'Orquídea phalaenopsis lilás de cinco ou seis hastes em arco, cheia de flores lavanda de garganta magenta, plantada em aquário redondo de vidro grande com casca de pinus, musgo e raízes aéreas, sobre bancada de mármore claro, junto a uma janela alta.' }
          ],
          precos: { mensal: 900 } }
      ] },
    { id: 'arranjo', nome: 'Arranjo de flores',
      d: 'Você assina e recebe as flores da época, montadas na manhã de cada entrega.',
      portes: [
        { id: 'pocket',  nome: 'Pocket',  d: '10 hastes + folhagem',
          img: '//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-assina-porte-pocket.jpg?v=21524271670799893021792599447?v=14',
          alt: 'Arranjo Pocket: dez hastes em vaso cilíndrico de vidro sobre uma base de travertino, perto da janela — duas rosas pêssego, três lisiantos com botões, três astromélias e uma boca-de-leão, com eucalipto e uma folha de monstera. As flores ficam baixas, logo acima da boca do vaso.',
          precos: { mensal: 119, quinzenal: 219, semanal: 399 } },
        { id: 'classic', nome: 'Classic', d: '15 hastes + folhagem',
          img: '//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-assina-porte-classic.jpg?v=123252641028913772241792599716?v=15',
          alt: 'Arranjo Classic: quinze hastes no mesmo vaso, na mesma mesa e na mesma distância de câmera do Pocket — quatro rosas pêssego, quatro lisiantos, seis astromélias e uma boca-de-leão, com eucalipto e monstera. O arranjo é mais cheio e continua baixo.',
          precos: { mensal: 149, quinzenal: 279, semanal: 499 } },
        { id: 'premium', nome: 'Premium', d: '20 hastes + folhagem',
          img: '//www.edelweissfloricultura.com.br/cdn/shop/t/3/assets/edelweiss-assina-porte-premium.jpg?v=35034783697254277781792599716?v=15',
          alt: 'Arranjo Premium: vinte hastes no mesmo vaso, na mesma mesa e na mesma distância de câmera dos outros dois — cinco rosas pêssego, lisiantos, sete ou oito astromélias e uma boca-de-leão, com muitos botões, eucalipto e monstera. É o mais cheio dos três, com a copa cobrindo toda a boca do vaso.',
          precos: { mensal: 199, quinzenal: 369, semanal: 649 } }
      ] }
  ];

  /* PRECO DO ADMIN (26/10/2026), como nas outras lojas. Cada plano e um produto
     com tag `assinatura` no admin, uma variante por frequencia, SKU
     assina-<tipo>-<porte>-<freq> (ex.: assina-arranjo-classic-quinzenal). O
     `theme.liquid` publica `window.EDW_ASSINA` (SKU -> preco) e ele manda aqui;
     sem o produto no admin, vale a tabela acima. */
  (function () {
    var m = window.EDW_ASSINA || {};
    TIPOS.forEach(function (t) {
      t.portes.forEach(function (p) {
        Object.keys(p.precos).forEach(function (f) {
          var v = m['assina-' + t.id + '-' + p.id + '-' + f];
          if (typeof v === 'number' && v > 0) p.precos[f] = v;
        });
      });
    });
  })();

  /* `porMes` não entra mais em conta de preço — o preço vem da tabela. Ele
     serve para duas coisas: dizer quantas entregas o plano tem, e dividir a
     mensalidade para mostrar quanto sai cada entrega, que é onde o desconto
     da frequência fica visível sem a página precisar anunciar percentual. */
  var FREQUENCIAS = [
    { id: 'semanal',   nome: 'Toda semana',              d: 'A flor nunca passa da semana', porMes: 4 },
    { id: 'quinzenal', nome: 'De quinze em quinze dias', d: 'O meio-termo',                 porMes: 2 },
    { id: 'mensal',    nome: 'Uma vez por mês',          d: 'Presença constante',           porMes: 1 }
  ];

  var estado = { tipo: 'arranjo', porte: 'classic', freq: 'quinzenal', cor: 'branca' };

  function preco(p, f) { return p.precos[f || estado.freq]; }

  function acha(lista, id) {
    return lista.filter(function (x) { return x.id === id; })[0] || lista[0];
  }
  function tipo()  { return acha(TIPOS, estado.tipo); }
  function porte() { return acha(tipo().portes, estado.porte); }
  function freq()  { return acha(freqsDoTipo(), estado.freq); }

  /* COR: só alguns tamanhos têm (hoje, a Média da orquídea). `corDe(p)` devolve
     a cor escolhida se o tamanho tem cores, ou null — e o null é o que faz o
     grupo "Qual cor" sumir nos outros tamanhos. */
  function corDe(p) { return (p && p.cores) ? acha(p.cores, estado.cor) : null; }
  /* Um tamanho sem `cores` existe só em branca. */
  function suporta(p, corId) {
    return p.cores ? p.cores.some(function (c) { return c.id === corId; }) : corId === 'branca';
  }
  function nomeDe(p) { var c = corDe(p); return p.nome + (c ? ' ' + c.nome.toLowerCase() : ''); }

  /* Um tipo pode restringir as frequências (a orquídea só tem a mensal). Sem
     a lista, valem as três. A ordem é sempre a de FREQUENCIAS, para os cartões
     não trocarem de lugar quando o cliente vai e volta entre os dois tipos. */
  function freqsDoTipo(t) {
    var permitidas = (t || tipo()).freqs;
    if (!permitidas) return FREQUENCIAS;
    return FREQUENCIAS.filter(function (f) { return permitidas.indexOf(f.id) !== -1; });
  }

  /* =======================================================================
     A NOTA DE HONESTIDADE

     Flor de corte não atravessa o mês: na frequência mensal, a peça passa
     parte do intervalo já sem a flor de abertura. A página diz isso em vez de
     aceitar calada — avisar que o plano escolhido rende menos do que parece é
     o que separa assinatura de armadilha.

     A NOTA IRMÃ, sobre orquídea + semanal, SAIU em 14/08/2026, e não por
     mudança de opinião: a orquídea passou a ter só a frequência mensal, então
     a combinação que ela advertia deixou de ser possível de montar na tela.
     Se a semanal voltar a existir para orquídea, a nota volta com ela.
     ======================================================================= */
  function nota() {
    if (estado.tipo === 'arranjo') {
      var epoca = 'Flores da época: as flores de cada entrega variam conforme a estação, ' +
                  'e o tamanho escolhido define quantas hastes vão em cada arranjo.';
      if (estado.freq !== 'mensal') return epoca;
      /* A frase agora ACONSELHA, e não só adverte. A versão anterior parava em
         "a peça passa parte do intervalo já sem a flor de abertura": dizia o
         problema e deixava o cliente sozinho com ele, e "flor de abertura" é
         palavra de florista, não de quem compra. Terminar oferecendo a
         quinzenal é o que transforma a advertência em ajuda — e é a mesma
         régua do resto do site, que já desaconselha o plano mais caro. */
      return epoca + ' Flor de corte não atravessa o mês. Na mensal, os últimos dias ficam ' +
             'sem flor aberta. Se isso incomodar, a quinzenal resolve.';
    }
    if (estado.tipo === 'orquidea') {
      /* MESMO FATO, SEM A FLOR MURCHA. A versão anterior fechava em "não repor
         flor murcha", e essa era a última imagem que o cliente levava antes de
         apertar o botão. O fato é bom — a peça dura o mês inteiro e é trocada
         por inteiro —, e a frase agora termina nele. */
      return 'Orquídea é planta viva e fica de pé o mês inteiro. Por isso a ' +
             'assinatura dela é mensal: todo mês a gente troca a peça inteira.';
    }
    return '';
  }

  /* =======================================================================
     O AVISO DE COR DA ORQUÍDEA (19/08/2026)

     AS TRÊS FOTOS DA ORQUÍDEA SÃO DA BRANCA — é o que a série publicada
     mostra e o que os três textos alternativos descrevem. Foto é promessa:
     quem escolhe o tamanho olhando para três vidros de flor branca sai da
     página achando que a cor já está decidida, e só descobre o contrário na
     conversa. O aviso desfaz isso NO LUGAR ONDE A PROMESSA É FEITA — embaixo
     dos cartões de tamanho, e não lá no resumo.

     POR QUE NÃO É UMA `resumo__nota`. O filete daquela classe marca a LETRA
     FINA DO RESUMO — o que fica colado no preço, dentro do cartão. Esta frase
     mora embaixo dos cartões de tamanho, longe do preço, e abre uma
     possibilidade em vez de fechar uma. Empilhá-la com o mesmo filete faria
     ler como mais uma ressalva do plano.
     (Até 19/08/2026 o filete queria dizer "isto adverte"; deixou de querer
     quando a observação da divisão do preço passou a usar a mesma classe —
     ver o comentário de `.resumo__nota` no styles.css.)

     E POR QUE NÃO VIRA UM GRUPO DE ESCOLHA NA TELA. Cor de orquídea depende
     do que chegou no mercado; publicar uma lista de cores seria prometer
     estoque que a página não tem como conferir. Quem confirma é a loja, e por
     isso o link já abre a conversa com a pergunta escrita — a pessoa não
     precisa reformular o pedido do outro lado.

     O link nasce com `E.WHATSAPP` na mão, e não com `data-whatsapp`: o app.js
     carimba esse atributo uma vez só, na carga da página, e este parágrafo é
     redesenhado depois, a cada troca de tipo. Só o href montado aqui sobrevive
     ao redesenho — é o mesmo motivo do botão do resumo.
     ======================================================================= */
  function avisoPorte() {
    /* ARRANJO (21/10/2026): o cliente compra a ASSINATURA, não um buquê
       específico. Recebe as flores da época, e a composição muda a cada
       entrega. A foto mostra o tamanho do arranjo, não as flores exatas. */
    if (estado.tipo === 'arranjo') {
      return '<strong>Você assina o plano e recebe as flores da época.</strong> ' +
             'Cada entrega é montada com o que chegou bom no mercado naquele dia, ' +
             'então as flores mudam de uma entrega para outra. As fotos mostram o ' +
             'tamanho do arranjo, não as flores exatas que você vai receber.';
    }
    if (estado.tipo !== 'orquidea') return '';
    var msg = 'Oi. Vi a assinatura de orquídea no site e queria saber sobre ' +
              'outras cores de orquídea.';
    return 'Branca e lilás são as cores que mais saem. Se você quiser outra cor, ' +
           '<a href="https://wa.me/' + E.WHATSAPP + '?text=' + encodeURIComponent(msg) +
           '" target="_blank" rel="noopener">fale com a loja</a> antes de assinar ' +
           '— a gente confirma a disponibilidade.';
  }

  /* ------------------------------------------------------------------ HTML */

  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  /* O preço no cartão do porte é o da FREQUÊNCIA ESCOLHIDA — por isso os três
     cartões se redesenham quando a frequência muda, e não só quando o tipo
     muda. Mostrar um preço fixo ali seria mentir em duas das três frequências. */
  /* A foto é do cartão, não do texto: entra ANTES do corpo e sangra até a
     borda, por isso o cartão com foto perde o padding e ele volta no corpo.
     Sem `img`, nada disso é emitido e o cartão fica como era.

     O INTERRUPTOR SE VIRA SOZINHO. Enquanto os três JPG não existirem em
     `site/img/`, o slot não é emitido e a página fica exatamente como era —
     sem retângulo vazio, que é pior do que não ter foto.

     Em vez de uma constante que alguém precisa lembrar de trocar, a página
     PERGUNTA ao navegador: carrega a primeira foto fora da tela e, se ela
     existir, redesenha o grupo de portes com as três. Nada de `fetch` nem de
     HEAD — servidor de arquivo estático devolve página de erro com status 200
     em algumas configurações, e aí o teste mentiria. O `onload` de um <img> só
     dispara com imagem que decodificou de verdade.

     Consequência prática: para publicar as fotos basta LARGAR OS JPG NA PASTA.
     Não se edita mais nada — nem este arquivo. Os prompts estão no
     13-brief-fotos-assinaturas.md.

     O INTERRUPTOR É POR GRUPO DESDE 18/08/2026, e não mais um só para a
     página inteira. Foi a orquídea passar de peça única para três tamanhos que
     obrigou: na época existia a foto da Grande e faltavam as da Mini e da Média. Com um
     interruptor único, o grupo abriria com um cartão ilustrado e dois com a
     chapa vazia — e aí o cliente compara fotografia em vez de comparar
     tamanho, que é o oposto do trabalho deste grupo.

     A regra passou a ser: O GRUPO SÓ GANHA FOTO QUANDO TODAS AS SUAS FOTOS
     CARREGAM. O arranjo, com as três na pasta, continua exatamente como
     estava; a orquídea volta a ter foto sozinha no dia em que as duas que
     faltam forem largadas na pasta, sem ninguém editar este arquivo. Isso
     também desfaz a armadilha antiga, que estava documentada no brief: quem
     apagasse a foto da orquídea desligava as fotos da página inteira, porque a
     sonda olhava só a primeira imagem da lista. Agora cada grupo responde por
     si. */
  var FOTOS_PRONTAS = {};

  function procuraAsFotos() {
    TIPOS.forEach(function (t) {
      var comImg = t.portes.filter(function (p) { return p.img; });
      /* Grupo misto — alguma opção sem `img` — não entra: o cartão sem foto
         ficaria mais baixo que os vizinhos e a série perderia a linha de base
         da comparação. */
      if (!comImg.length || comImg.length !== t.portes.length) return;
      var faltam = comImg.length;
      comImg.forEach(function (item) {
        var teste = new Image();
        teste.onload = function () {
          faltam -= 1;
          if (faltam) return;
          FOTOS_PRONTAS[t.id] = true;
          /* Só redesenha se o grupo que ficou pronto for o que está na tela.
             Redesenhar o outro jogaria fora a marcação do rádio visível. */
          if (estado.tipo === t.id) desenharPortes();
        };
        teste.src = item.img;
      });
    });
  }

  /* `estado.tipo` e não o tipo do item porque `foto()` só é chamada para as
     opções do grupo que está desenhado — tipo e frequência não têm imagem. */
  function temFoto(item) { return !!(FOTOS_PRONTAS[estado.tipo] && item.img); }

  /* O `?v=` do campo `img` nao e enfeite: as fotos trocam de CONTEUDO mantendo
     o NOME do arquivo, e a aba que ja estava aberta continua mostrando a
     antiga — o `no-store` do servidor so vale para requisicao nova. Foi
     exatamente isso em 18/08/2026, com a serie do arranjo trocada no disco e
     a pagina "sem mudar nada". Ao publicar uma serie nova, subir o numero.
     Mesma razao do `styles.css?v=10` e do `app.js?v=2`. */
  function foto(item) {
    if (!temFoto(item)) return '';
    var c = corDe(item);
    return '<span class="opcao__foto">' +
             '<img src="' + esc(c ? c.img : item.img) + '" alt="' + esc((c ? c.alt : item.alt) || '') + '"' +
               ' loading="lazy" decoding="async"' +
               ' onerror="this.style.display=&quot;none&quot;">' +
           '</span>';
  }

  function opcao(grupo, item, marcado, comPreco) {
    var comFoto = temFoto(item) ? ' opcao--foto' : '';
    return '<label class="opcao' + comFoto + (marcado ? ' is-on' : '') + '">' +
             '<input type="radio" name="' + grupo + '" value="' + item.id + '"' +
               (marcado ? ' checked' : '') + '>' +
             foto(item) +
             '<span class="opcao__corpo">' +
               '<span class="opcao__n">' + esc(item.nome) + '</span>' +
               '<span class="opcao__d">' + esc(item.d || '') + '</span>' +
               (comPreco ? '<span class="opcao__p">' + money(preco(item)) + ' por mês</span>' : '') +
             '</span>' +
           '</label>';
  }

  /* OPÇÃO ÚNICA NÃO É RÁDIO. Quando o grupo tem um item só — hoje só a
     frequência da orquídea, que é mensal e ponto —, ele deixa de ser escolha e
     vira informação. Um
     `radio` sozinho é um controle que não controla nada: entra na ordem de
     tabulação, promete alternativa e não tem nenhuma. O bloco abaixo tem a
     mesma forma dos outros, `aria-hidden` fora (ele é lido como texto) e sem
     input. */
  function fixa(item, comPreco) {
    var comFoto = temFoto(item) ? ' opcao--foto' : '';
    return '<div class="opcao opcao--fixa' + comFoto + ' is-on">' +
             foto(item) +
             '<span class="opcao__corpo">' +
               '<span class="opcao__n">' + esc(item.nome) + '</span>' +
               '<span class="opcao__d">' + esc(item.d || '') + '</span>' +
               (comPreco ? '<span class="opcao__p">' + money(preco(item)) + ' por mês</span>' : '') +
             '</span>' +
           '</div>';
  }

  function opcoesPorte() {
    var ps = tipo().portes;
    if (ps.length === 1) return fixa(ps[0], true);
    return ps.map(function (x) {
      return opcao('porte', x, x.id === estado.porte, true);
    }).join('');
  }

  function opcoesFreq() {
    var fs = freqsDoTipo();
    if (fs.length === 1) return fixa(fs[0], false);
    return fs.map(function (x) {
      return opcao('freq', x, x.id === estado.freq, false);
    }).join('');
  }

  /* O ESQUELETO É DESENHADO UMA VEZ SÓ. Só o grupo de portes e o resumo se
     redesenham, e por um motivo de teclado: recriar o formulário inteiro a
     cada clique joga o foco de volta para o começo da página, e quem navega
     por Tab perde o lugar a cada escolha. */
  function desenharEsqueleto() {
    alvo.innerHTML =
      '<div class="assina">' +
        '<form class="assina__escolhas">' +
          '<fieldset class="assina__grupo">' +
            '<legend class="assina__legenda">O que vem</legend>' +
            '<div class="assina__opcoes">' +
              TIPOS.map(function (x) {
                return opcao('tipo', x, x.id === estado.tipo, false);
              }).join('') +
            '</div>' +
          '</fieldset>' +
          /* A cor vem antes do tamanho. Nasce escondida: só o tipo com `cores` a mostra. */
          '<fieldset class="assina__grupo" data-grupo-cor hidden>' +
            '<legend class="assina__legenda">Qual cor</legend>' +
            '<div class="assina__opcoes assina__opcoes--cor" data-cores></div>' +
          '</fieldset>' +
          '<fieldset class="assina__grupo">' +
            '<legend class="assina__legenda" data-legenda-porte></legend>' +
            '<div class="assina__opcoes" data-portes></div>' +
            /* Nasce escondido e vazio: quem o enche é o desenharPortes(),
               que já roda uma vez na abertura da página. */
            '<p class="assina__aviso" data-aviso-porte hidden></p>' +
          '</fieldset>' +
          '<fieldset class="assina__grupo">' +
            '<legend class="assina__legenda">De quanto em quanto tempo</legend>' +
            '<div class="assina__opcoes" data-freqs></div>' +
          '</fieldset>' +
        '</form>' +
        '<aside class="resumo" data-resumo aria-live="polite"></aside>' +
      '</div>';
  }

  function desenharPortes() {
    var leg = $('[data-legenda-porte]', alvo);
    /* "Que tamanho" e não "Que porte": é a palavra que a coluna da tabela da
       loja usa, e os nomes dos arranjos vêm de lá. Desde 18/08/2026 os dois
       tipos têm três tamanhos, então a legenda é sempre esta — o ramo "A peça"
       fica de pé só para o caso de algum tipo voltar a ter uma opção única. */
    if (leg) leg.textContent = tipo().portes.length === 1 ? 'A peça' : 'Que tamanho';
    var cx = $('[data-portes]', alvo);
    if (cx) cx.innerHTML = opcoesPorte();
    /* O aviso vive e morre com o grupo de tamanho: no arranjo ele some
       inteiro, em vez de ficar lá vazio ocupando margem. */
    var av = $('[data-aviso-porte]', alvo);
    if (av) {
      var texto = avisoPorte();
      av.innerHTML = texto;
      av.hidden = !texto;
    }
  }

  function desenharCores() {
    var g = $('[data-grupo-cor]', alvo), cx = $('[data-cores]', alvo);
    if (!g || !cx) return;
    var t = tipo();
    if (!t.cores) { g.hidden = true; cx.innerHTML = ''; return; }
    g.hidden = false;
    cx.innerHTML = t.cores.map(function (c) {
      var onde = t.portes.filter(function (p) { return suporta(p, c.id); });
      /* Se a cor não existe em todos os tamanhos, o cartão diz onde ela existe. */
      var d = onde.length < t.portes.length
        ? 'Disponível na ' + onde.map(function (p) { return p.nome; }).join(' e ') : '';
      return opcao('cor', { id: c.id, nome: c.nome, d: d }, c.id === estado.cor, false);
    }).join('');
  }

  function desenharFreqs() {
    var cx = $('[data-freqs]', alvo);
    if (cx) cx.innerHTML = opcoesFreq();
  }

  function desenharResumo() {
    var t = tipo(), p = porte(), f = freq(), n = nota();
    var mensal = preco(p);
    var porEntrega = mensal / f.porMes;
    /* Só a PRIMEIRA letra da descrição desce, porque a frase a encaixa no meio
       de um período. `toLowerCase()` na string inteira quebrou em 19/08/2026,
       quando a descrição da orquídea passou a terminar em "aquário M": virava
       "aquário m", que não é o nome do tamanho. */
    var desc = p.d.charAt(0).toLowerCase() + p.d.slice(1);
    var msg = 'Oi. Queria assinar: ' + (t.nomeLongo || t.nome).toLowerCase() + ' ' + nomeDe(p) +
              ' (' + desc + '), ' + f.nome.toLowerCase() + '. ' +
              (t.id === 'arranjo' ? 'Entendi que recebo as flores da época. ' : '') +
              'Vi na página que fica ' + money(mensal) + ' por mês.';

    var cx = $('[data-resumo]', alvo);
    if (!cx) return;
    cx.innerHTML =
      '<p class="resumo__r">A sua assinatura</p>' +
      '<p class="resumo__t">' + esc(t.nomeLongo || t.nome) + ' · ' + esc(nomeDe(p)) + '</p>' +
      /* A COMPOSIÇÃO ENTROU NO RESUMO (19/08/2026). "Classic" é nome de plano:
         não diz nada sozinho. O fato concreto — "9 hastes + folhagem" — estava
         só no cartão lá em cima e no texto do WhatsApp, e sumia justamente no
         bloco que existe para confirmar a escolha. É a mesma descrição do
         cartão, sem reescrita: dois textos diferentes para a mesma peça é
         como se perde a confiança de quem confere antes de fechar. */
      '<p class="resumo__c">' + esc(p.d) + '</p>' +
      '<p class="resumo__f">' + esc(f.nome) + '</p>' +
      '<div class="resumo__linhas">' +
        /* A ÁREA DE ENTREGA VIROU LINHA DA TABELA, e saiu da letra miúda
           embaixo do botão. Onde a flor chega é condição do negócio, não
           rodapé: quem mora fora do Plano Piloto precisa descobrir isso ANTES
           de abrir a conversa, e não depois. A ordem das linhas passou a ser
           a ordem das perguntas: onde, quantas, quanto cada uma, quanto no
           mês. */
        '<div class="resumo__l"><span>Área de entrega</span><span>Plano Piloto</span></div>' +
        '<div class="resumo__l"><span>Entregas no mês</span><span>' + f.porMes + '</span></div>' +
        /* "Cada entrega sai por" é a linha que faz o desconto da frequência
           aparecer sem a página anunciar percentual: no Pocket ela cai de
           R$ 119,00 na mensal para R$ 99,75 na semanal. É conta derivada, não
           preço de venda — daí o verbo "sai por", e não "custa".
           NA MENSAL ELA SOME, junto com a observação de rodapé: com uma
           entrega por mês, "cada entrega sai por" repete o total na linha de
           cima, e uma linha que repete a seguinte só faz o leitor conferir se
           não leu errado. */
        (f.porMes > 1
          ? '<div class="resumo__l"><span>Cada entrega sai por</span><span>' +
              money(porEntrega) + '</span></div>'
          : '') +
        '<div class="resumo__l resumo__l--total"><span>Por mês</span><span>' + money(mensal) + '</span></div>' +
      '</div>' +
      (f.porMes > 1
        /* 21 palavras viraram 12. A frase é a última coisa lida antes do botão,
           e a versão anterior gastava esse lugar explicando a própria conta
           ("para dar para comparar as frequências" — que tropeça na leitura em
           voz alta). O medo que ela precisa matar é um só: o cliente achar que
           vai pagar por entrega. Ela mata em duas frases e sai da frente. */
        ? '<p class="resumo__nota">Você paga a mensalidade. O valor por entrega ' +
          'é só a divisão dela.</p>'
        : '') +
      (n ? '<p class="resumo__nota">' + n + '</p>' : '') +
      '<a class="btn btn--acento btn--lg btn--block" target="_blank" rel="noopener"' +
        ' href="https://wa.me/' + E.WHATSAPP + '?text=' + encodeURIComponent(msg) + '">' +
        'Assinar pelo WhatsApp</a>' +
      /* LINHA DE BAIXO DO BOTÃO: UMA LINHA, E ELA TIRA RISCO.
         A área de entrega saiu daqui e virou linha da tabela (acima). O que
         sobrou é o trabalho que essa posição faz melhor do que qualquer outra:
         desarmar o medo de que apertar o botão já compromete alguém. Nada é
         cobrado ali — o botão abre uma conversa —, e dizer isso vale mais do
         que repetir o que a loja confirma depois.
         "Janela" saiu da frase: desde que a seção "O que já está combinado"
         foi removida, o horário de manhã e tarde não é explicado em lugar
         nenhum desta página, e a palavra ficou sem referente. Era também a
         palavra que empurrava a linha para duas — letra miúda em duas linhas
         embaixo de um botão puxa o olho para longe dele. */
      '<p class="confianca">Nada é cobrado agora. Você combina endereço e ' +
      'data com a loja.</p>';

    if (window.lucide && window.lucide.createIcons) window.lucide.createIcons();
  }

  /* O estado visual do rótulo não sai de `:checked` no CSS porque o input é
     irmão anterior do texto, e o seletor teria de ser `:has()`. A classe
     resolve em todo navegador e deixa o CSS legível. */
  function marcar(nomeGrupo, valor) {
    var inputs = alvo.querySelectorAll('input[name="' + nomeGrupo + '"]');
    Array.prototype.forEach.call(inputs, function (i) {
      i.parentNode.classList.toggle('is-on', i.value === valor);
    });
  }

  /* Delegação no container, que não é substituído — os inputs são. */
  alvo.addEventListener('change', function (ev) {
    var el = ev.target;
    if (!el || el.type !== 'radio') return;

    if (el.name === 'tipo') {
      estado.tipo = el.value;
      var novo = acha(TIPOS, el.value);
      /* Trocar de tipo troca o eixo inteiro: 'media' não existe entre os
         tamanhos do arranjo, nem 'classic' entre os da orquídea. Cai no do
         MEIO, que é o equivalente do que estava escolhido — voltar sempre ao
         primeiro faria a escolha do cliente encolher sozinha a cada troca.
         Com os dois tipos em três tamanhos desde 18/08/2026, a correspondência
         virou de posição e não mais de aproximação: quem estava no Classic cai
         na Média, e quem estava na Média volta para o Classic. */
      estado.porte = (novo.portes[1] || novo.portes[0]).id;
      /* Cor volta para a primeira (branca) ao trocar de tipo. */
      estado.cor = (novo.cores && novo.cores[0]) ? novo.cores[0].id : 'branca';
      /* E a frequência pode não existir no tipo novo: a orquídea só tem a
         mensal. Sem esta linha, escolher "toda semana" no arranjo e trocar
         para orquídea deixava o estado numa frequência sem preço, e o resumo
         mostrava "R$ NaN". */
      var fs = freqsDoTipo(novo);
      if (!fs.filter(function (f) { return f.id === estado.freq; }).length) {
        estado.freq = fs[0].id;
      }
      marcar('tipo', estado.tipo);
      desenharPortes();
      desenharCores();
      desenharFreqs();
    } else if (el.name === 'porte') {
      estado.porte = el.value;
      marcar('porte', estado.porte);
      /* Tamanho que não existe na cor escolhida: a cor volta para a branca. */
      if (!suporta(porte(), estado.cor)) {
        estado.cor = 'branca';
        desenharCores();
        desenharPortes();
      }
    } else if (el.name === 'cor') {
      estado.cor = el.value;
      marcar('cor', estado.cor);
      /* Cor que o tamanho escolhido não tem: vai para o primeiro que tem (a Média,
         no caso da lilás). */
      if (!suporta(porte(), estado.cor)) {
        var ok = tipo().portes.filter(function (p) { return suporta(p, estado.cor); })[0];
        if (ok) estado.porte = ok.id;
      }
      /* A foto do cartão do tamanho acompanha a cor: redesenha o grupo. */
      desenharPortes();
    } else if (el.name === 'freq') {
      estado.freq = el.value;
      marcar('freq', estado.freq);
      /* O preço estampado em cada porte é o da frequência escolhida, então
         trocar a frequência obriga a redesenhar os três cartões. Sem isto a
         página mostrava R$ 279 no cartão do Classic com a semanal marcada. */
      desenharPortes();
    }
    desenharResumo();
  });

  desenharEsqueleto();
  desenharPortes();
  desenharCores();
  desenharFreqs();
  desenharResumo();
  /* Por último, e sem bloquear nada: se as fotos já estiverem na pasta, o
     grupo de portes se redesenha com elas em seguida. Se não estiverem, esta
     linha não faz diferença nenhuma na página. */
  procuraAsFotos();
})();
